<app-number [value]="fontSize" (sendValue)="receiveValue($event)" [color]="color" [min]="6" [max]="48" [step]="2"></app-number>